import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CanalAtencionService } from '../../../services/canalAtencion.service';
import { DirigidoTramiteService } from '../../../services/dirigidoTramite.service';
import { EnfoqueDiferencialService } from '../../../services/enfoqueDiferencial.service';
import { CaracteristicaEspecialService } from '../../../services/caracteristicaEspecial.service';
import { ButtonModule } from 'primeng/button';
import { AuthService, LocalService, AlertService } from 'lib-base';
import { firstValueFrom, forkJoin, Subscription } from 'rxjs';
import { MessageService } from 'primeng/api';
import { AuthenticationManagerService } from '../../../services/authentication-manager.service';
 import {
  IGetCanalAtencion, IGetCaracteristicaEspecial, IGetDirigidoTramite,
  IGetEnfoqueDiferencial, IGetHojaDeVidaTramite, IGetTramitesBusqueda, IIdCompuestoVersion
} from '../../../shared/interfaces/configuracion';
import { HttpErrorResponse } from '@angular/common/http';
import { TipoTramiteService } from '../../../services/tipoTramite.service';
import {AlertIcon, ResponseAlert} from "../../../../../../lib-base/src/lib/shared";
import {TramRegistroSolicitudService} from "../../../services/tramiteRegistroSolicitud.service";
import {IValidarTramiteActivo} from "../../../shared/interfaces/tramite";

@Component({
  selector: 'app-ver-informacion-tramite',
  standalone: true,
  imports: [CommonModule, TranslateModule,
    ButtonModule
  ],
  templateUrl: './ver-informacion-tramite.component.html',
  styleUrl: './ver-informacion-tramite.component.scss'
})
export class VerInformacionTramiteComponent implements OnInit, OnDestroy {
  private _tipoTramiteId !: number;
  private _dependenciaId !: number;
  private _previousSearch !: string;

  private _tramiteBusqueda !: IGetTramitesBusqueda;
  hojaDeVida !: IGetHojaDeVidaTramite;
  isLoading: boolean = false;
  private readonly JURIDICA = 'JURIDICA';
  private readonly NATURAL = 'NATURAL';

  canalesAtencion: any[] = [];
  dirigidoTramite: any[] = [];
  enfoqueDiferencial: any[] = [];
  caracteristicasEspeciales: any[] = [];

  private _loginSubscription !: Subscription;
  private _menuCloseSubscription !: Subscription;
  private basePath: string = '';

  private _translations: any = {};

  constructor(private readonly _ar: ActivatedRoute, private readonly _router: Router, private readonly _ls: LocalService,
    private readonly _ca: CanalAtencionService, private readonly _dt: DirigidoTramiteService, private readonly _ed: EnfoqueDiferencialService, private readonly _ce: CaracteristicaEspecialService,
    private readonly _ms: MessageService, private readonly _ams: AuthenticationManagerService, private readonly _translate: TranslateService, private readonly _as: AuthService, private readonly _tt: TipoTramiteService,
              private readonly alertService: AlertService, private readonly _trs: TramRegistroSolicitudService
  ) { }

  ngOnDestroy(): void {
    this.unsubscribe();
  }

  ngOnInit() {
    this._tipoTramiteId = Number(this._ar.snapshot.params['tipoTramiteId']);
    this._dependenciaId = Number(this._ar.snapshot.params['dependenciaId']);
    this._previousSearch = this._ar.snapshot.queryParamMap.get('search') ?? '';

    this.translate();
    this.getTramiteBusquedaByTipoTramiteIdAndDependenciaId();
    this.getHojaDeVidaTramite();
    this._ar.parent?.url.subscribe((url) => {
      this.basePath = url[0]?.path;
    });
  }

  private async translate(): Promise<void> {
    this._translations = await firstValueFrom(forkJoin({
      warnSummary: this._translate.get('form.msg.warn-summary'),
      necesitaPersonaJuridica: this._translate.get('components.app-resultados-busqueda.necesita-persona-juridica'),
      necesitaPersonaJuridicaOpcional: this._translate.get('components.app-resultados-busqueda.necesita-persona-juridica-opcional'),
      personaJuridica: this._translate.get('components.app-resultados-busqueda.persona-juridica'),
      personaNatural: this._translate.get('components.app-resultados-busqueda.persona-natural'),
      cancelar: this._translate.get('form.button.cancelar'),
      tramiteCanceladoPersonaJuridica: this._translate.get('components.app-resultados-busqueda.tramite-cancelado-persona-juridica'),
      inicioSesionCancelado: this._translate.get('components.app-resultados-busqueda.inicio-sesion-cancelado'),
      yaExisteUnTramiteActivo: this._translate.get('msg.yaExiteUnTramiteActivo'),
    }));
  }

  unsubscribe() {
    if (this._loginSubscription) {
      this._loginSubscription.unsubscribe();
    }
    if (this._menuCloseSubscription) {
      this._menuCloseSubscription.unsubscribe();
    }
  }

  goToPage() {
    this._router.navigate([this.basePath,'consulta', this._previousSearch]).then();
  }

  private tramiteConfig() {
    let requierePersonaJuridica: boolean = false;
    let requierePersonaNatural: boolean = false;

    this._tramiteBusqueda.dirigidoTramite.forEach((dt: string) => {
      if (dt) {
        if (dt === this.JURIDICA) {
          requierePersonaJuridica = true;
        } else if (dt === this.NATURAL) {
          requierePersonaNatural = true;
        }
      }
    });

    const customComponentId = {
      id: this._tramiteBusqueda.customComponentId,
      version: this._tramiteBusqueda.customComponentVersion
    } as IIdCompuestoVersion;

    if (requierePersonaJuridica) {
      let text = this._translations.necesitaPersonaJuridica;
      if (requierePersonaNatural) {
        text = this._translations.necesitaPersonaJuridicaOpcional;
      }

      this.alertService.show({
        data: {
          text: text,
          icon: AlertIcon.QUESTION,
          showAccept: true,
          textAccept: this._translations.personaJuridica,
          showCancel: true,
          textCancel: requierePersonaNatural ? this._translations.personaNatural : this._translations.cancelar,
        },
        closable: true
      }).subscribe((obj:ResponseAlert) => {
        if (obj.accept) {
          this._menuCloseSubscription = this._ams.closeSource$.subscribe(empresaId => {
            this.unsubscribe();
            this.validateTramite({
              dependenciaId: this._tramiteBusqueda.dependenciaId,
              tramiteId: this._tramiteBusqueda.id,
              customComponent: customComponentId,
              empresaId: empresaId
            });
          });
          this._ams.onOpenTab(3);
        } else if (obj.cancel) {
          if (requierePersonaNatural) {
            this.validateTramite({
              dependenciaId: this._tramiteBusqueda.dependenciaId,
              tramiteId: this._tramiteBusqueda.id,
              customComponent: customComponentId,
            });
          } else {
            this._ms.add({ severity: 'warn', summary: this._translations.warnSummary, detail: this._translations.tramiteCanceladoPersonaJuridica });
          }
        }
      });
    } else {
      this.validateTramite({
        dependenciaId: this._tramiteBusqueda.dependenciaId,
        tramiteId: this._tramiteBusqueda.id,
        customComponent: customComponentId,
      });
    }
  }

  onIniciarTramite() {
    if(this._tramiteBusqueda.requierePago && !this._tramiteBusqueda.costoVigente){
      this._ms.add({ severity: 'warn', summary: this._translations.warnSummary,
        detail: this._translations.tramiteInactivo });
      return;
    }

    if (this._ls.isLoggedIn) {
      this.tramiteConfig();
      return;
    }

    this._loginSubscription = this._as.loginSource$.subscribe(() => {
      this.tramiteConfig();
      this.unsubscribe();
    });

    this._menuCloseSubscription = this._ams.closeSource$.subscribe(key => {
      this.unsubscribe();
      this._ms.add({ severity: 'warn', summary: this._translations.warnSummary, detail: this._translations.inicioSesionCancelado });
    });

    this._ams.onMenuOpen();
  }

  private crearTramiteRedirect( props:any[], customComp?:IIdCompuestoVersion){
    this._router.navigate(['/tramites/crear-tramite',...props],
      {
        state: {data: customComp }
      }).then();
  }

  //#region API

  getCanalesAtencions() {
    this._ca.getCanalesAtencions().subscribe({
      next: (response: IGetCanalAtencion[]) => {
        response.forEach(i => {
          let item = {
            text: i.nombre,
            selected: this.hojaDeVida.canalesAtencionIds.includes(i.id)
          };
          this.canalesAtencion.push(item);
        });
      }
    });
  }

  getDirigidoTramite() {
    this._dt.getDirigidoTramite().subscribe({
      next: (response: IGetDirigidoTramite[]) => {
        response.forEach(i => {
          let item = {
            text: i.nombre,
            selected: this.hojaDeVida.dirigidoTramiteIds.includes(i.id)
          };
          this.dirigidoTramite.push(item);
        });

      }
    });
  }

  getEnfoqueDiferencial() {
    this._ed.getEnfoqueDiferencial().subscribe({
      next: (response: IGetEnfoqueDiferencial[]) => {
        response.forEach(i => {
          let item = {
            text: i.nombre,
            selected: this.hojaDeVida.enfoqueDiferencialIds.includes(i.id)
          };
          this.enfoqueDiferencial.push(item);
        });
      }
    });
  }

  getCaracteristicaEspecial() {
    this._ce.getCaracteristicaEspecial().subscribe({
      next: (response: IGetCaracteristicaEspecial[]) => {
        response.forEach(i => {
          let item = {
            text: i.nombre,
            selected: this.hojaDeVida.caracteristicaEspecialIds.includes(i.id)
          };
          this.caracteristicasEspeciales.push(item);
        });
      }
    });
  }

  getHojaDeVidaTramite() {
    this.isLoading = true;
    this._tt.getHojaDeVidaTramiteById(this._tipoTramiteId).subscribe({
      next: (data: IGetHojaDeVidaTramite) => {
        this.hojaDeVida = data;
        this.getCanalesAtencions();
        this.getDirigidoTramite();
        this.getEnfoqueDiferencial();
        this.getCaracteristicaEspecial()
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  getTramiteBusquedaByTipoTramiteIdAndDependenciaId() {
    this.isLoading = true;
    this._tt.getTramiteBusquedaByTipoTramiteIdAndDependenciaId(this._tipoTramiteId, this._dependenciaId).subscribe({
      next: (td: IGetTramitesBusqueda) => {
        this._tramiteBusqueda = td;
        this.isLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.isLoading = false;
      }
    });
  }

  validateTramite(props: IValidarTramiteActivo) {
    firstValueFrom(this._trs.tieneTramiteActivo(props.tramiteId))
      .then(response => {
        if (response) {
          this._ms.add({
            severity: 'warn',
            summary: this._translations.warnSummary,
            detail: this._translations.yaExisteUnTramiteActivo
          });
           return;
        }
        const paramsArray = [props.tramiteId, props.dependenciaId, props.empresaId].filter(it => it != undefined);
        this.crearTramiteRedirect(paramsArray, props.customComponent)
      });
  }

  //#endregion API
}
